import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import AppContextProvider from '@projectK/context/AppContextProvider';
import AppThemeProvider from '@projectK/context/AppThemeProvider';
import AppStyleProvider from '@projectK/context/AppStyleProvider';
import AppLocaleProvider from '@projectK/context/AppLocaleProvider';
import InfoViewContextProvider from '@projectK/context/InfoViewContextProvider';
import AppAuthProvider from './core/AppAuthProvider';
import AuthRoutes from '@projectK/components/AuthRoutes';
import AppLayout from './core/AppLayout';
import CalendarSyncStatusPopup from './core/CalendarSyncStatusPopup';
import './assets/styles/maps.css';

const App = () => (
  <AppContextProvider>
    <AppThemeProvider>
      <AppStyleProvider>
        <AppLocaleProvider>
          <BrowserRouter>
            <InfoViewContextProvider>
              <AppAuthProvider>
                <AuthRoutes>
                  <CssBaseline />
                  <AppLayout />
                  <CalendarSyncStatusPopup />
                </AuthRoutes>
              </AppAuthProvider>
            </InfoViewContextProvider>
          </BrowserRouter>
        </AppLocaleProvider>
      </AppStyleProvider>
    </AppThemeProvider>
  </AppContextProvider>
);

export default App;
